import { BrandSetup, MainLayout } from '../components'

export const BrandSetupPage: React.FC = () => {
	return (
		<MainLayout>
			<BrandSetup />
		</MainLayout>
	)
}
